import React from "react";
import styled from "styled-components/macro";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import TitleSection from "src/components/TitleSection/TitleSection";
import { Row, Col } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import Button from "src/components/Button/Button";
import useResponsiveImageUrl from "src/utils/useResponsiveImageUrl";
import EventFinished from "src/components/EventFinished";
import Hero from "src/components/Hero/Hero";

const NewYearsEve2026 = () => {
  const { i18n } = useTranslation();

  return (
    <Div
      bgImage={useResponsiveImageUrl(
        "entertainment/variety/new-years-eve-2026/LP-NYE-2025-background-3.jpg"
      )}
    >
      <EventFinished scheduleKeyName="newYearsEve2026" eventType="event" />

      {/* Hero Section with Logo */}
      <Hero
        // bgImage="entertainment/variety/new-years-eve-2026/LP-NYE-2025-Banner.jpg"
        image={`entertainment/variety/new-years-eve-2026/LP-NYE-2025-logo-en-option1.png`}
        imageAlt={t("entertainment.newYearsEve2026.hero.imageAlt")}
        fluidImage={false}
      />

      <MainContentDiv>
        {/* Pre-sale Info Banner */}
        <container-div>
          <SectionWrapper>
            <PreSaleBanner>
              <TitleSection
                as={"h2"}
                title={t("entertainment.newYearsEve2026.content.intro.title")}
                text={t("entertainment.newYearsEve2026.content.intro.subtitle")}
                dark={false}
                borderColor="#D59947"
              />
              <PreSaleFrame>
                <ResponsiveImage
                  src="entertainment/variety/new-years-eve-2026/LP-NYE-2025-TOP-IMAGE.jpg"
                  alt="New Year's Eve 2026"
                />
                {/* <PreSaleBar />
                <PreSaleText>
                  {t("entertainment.newYearsEve2026.preSale.badge")}
                </PreSaleText> */}
              </PreSaleFrame>
              <ReactMarkdown>
                {t("entertainment.newYearsEve2026.preSale.text")}
              </ReactMarkdown>
            </PreSaleBanner>
          </SectionWrapper>
        </container-div>
        {/* Dining Experiences Section */}
        <container-div>
          <SectionWrapper>
            <TitleSection
              as={"h2"}
              title={t("entertainment.newYearsEve2026.content.dining.title")}
              text={t("entertainment.newYearsEve2026.content.dining.subtitle")}
              dark={false}
              borderColor="#D59947"
            />

            <Row className="g-4 mb-4">
              {/* Seating 1 - Elvis Tribute */}
              <Col xs={12} md={6}>
                <DiningCard>
                  <div className="image-wrapper">
                    <ResponsiveImage
                      src={`entertainment/variety/new-years-eve-2026/LP-NYE 2025-SEATING1-SOLD-OUT-${i18n.language}.jpg`}
                      alt="Elvis Tribute - Seating 1"
                    />
                    <div className="seating-badge">
                      <ReactMarkdown className="seating-info">
                        {t(
                          "entertainment.newYearsEve2026.content.dining.seating1.badge"
                        )}
                      </ReactMarkdown>
                      <ReactMarkdown className="seating-info-2">
                        {t(
                          "entertainment.newYearsEve2026.content.dining.seating1.time"
                        )}
                      </ReactMarkdown>
                    </div>
                  </div>
                  <div className="card-content">
                    <h3>
                      {t(
                        "entertainment.newYearsEve2026.content.dining.seating1.title"
                      )}
                    </h3>
                    <ReactMarkdown className="performer">
                      {t(
                        "entertainment.newYearsEve2026.content.dining.seating1.performer"
                      )}
                    </ReactMarkdown>
                    <p className="price">
                      {t(
                        "entertainment.newYearsEve2026.content.dining.seating1.price"
                      )}
                    </p>
                    {/* <Button
                      bgColor="#D59947"
                      href={t(
                        "entertainment.newYearsEve2026.content.dining.seating1.menuLink"
                      )}
                      label={t(
                        "entertainment.newYearsEve2026.content.dining.seating1.menuText"
                      )}
                      color="var(--lightblack)"
                      hoverBgColor="#e6b366"
                      width="wide"
                    /> */}
                  </div>
                </DiningCard>
              </Col>

              {/* Seating 2 - Top 40 Pop */}
              <Col xs={12} md={6}>
                <DiningCard>
                  <div className="image-wrapper">
                    <ResponsiveImage
                      src={`entertainment/variety/new-years-eve-2026/LP-NYE 2025-SEATING2-SOLD-OUT-${i18n.language}.jpg`}
                      alt="Top 40 Pop - Seating 2"
                    />
                    <div className="seating-badge">
                      <ReactMarkdown className="seating-info">
                        {t(
                          "entertainment.newYearsEve2026.content.dining.seating2.badge"
                        )}
                      </ReactMarkdown>
                      <ReactMarkdown className="seating-info-2">
                        {t(
                          "entertainment.newYearsEve2026.content.dining.seating2.time"
                        )}
                      </ReactMarkdown>
                    </div>
                  </div>
                  <div className="card-content">
                    <h3>
                      {t(
                        "entertainment.newYearsEve2026.content.dining.seating2.title"
                      )}
                    </h3>
                    <ReactMarkdown className="performer">
                      {t(
                        "entertainment.newYearsEve2026.content.dining.seating2.performer"
                      )}
                    </ReactMarkdown>
                    <p className="price">
                      {t(
                        "entertainment.newYearsEve2026.content.dining.seating2.price"
                      )}
                    </p>
                    {/* <Button
                      bgColor="#D59947"
                      href={t(
                        "entertainment.newYearsEve2026.content.dining.seating2.menuLink"
                      )}
                      label={t(
                        "entertainment.newYearsEve2026.content.dining.seating2.menuText"
                      )}
                      color="var(--lightblack)"
                      hoverBgColor="#e6b366"
                      width="wide"
                    /> */}
                  </div>
                </DiningCard>
              </Col>
            </Row>

            <Row className="g-4 mb-4">
              {/* Drunken Dragon */}
              <Col xs={12} md={6}>
                <DiningCard>
                  <ResponsiveImage
                    src={`entertainment/variety/new-years-eve-2026/LP-NYE-2025-DRUNKEN-DRAGON-SOLD-OUT-${i18n.language}.jpg`}
                    alt="Drunken Dragon"
                  />
                  <div className="card-content">
                    <ResponsiveImage
                      className="restaurant-logo"
                      src="svg/DRUNKEN_DRAGON_LOGO_REGISTERED_WHITE.svg"
                      alt="Drunken Dragon"
                    />
                    <ReactMarkdown className="description">
                      {t(
                        "entertainment.newYearsEve2026.content.dining.drunkenDragon.title"
                      )}
                    </ReactMarkdown>
                    <p className="price">
                      {t(
                        "entertainment.newYearsEve2026.content.dining.drunkenDragon.price"
                      )}
                    </p>
                    {/* <Button
                      bgColor="#D59947"
                      href={t(
                        "entertainment.newYearsEve2026.content.dining.drunkenDragon.menuLink"
                      )}
                      label={t(
                        "entertainment.newYearsEve2026.content.dining.drunkenDragon.menuText"
                      )}
                      color="var(--lightblack)"
                      hoverBgColor="#e6b366"
                      width="wide"
                    />
                    <Button
                      bgColor="#D59947"
                      href={t(
                        "dining.dining.drunkenDragon.buttons.reserve.link"
                      )}
                      label={t("dining.dining.drunkenDragon.buttons.reserve.text")}
                      color="var(--lightblack)"
                      hoverBgColor="#e6b366"
                      width="wide"
                    /> */}
                  </div>
                </DiningCard>
              </Col>

              {/* etc. */}
              <Col xs={12} md={6}>
                <DiningCard>
                  <ResponsiveImage
                    src={`entertainment/variety/new-years-eve-2026/LP-NYE-2025-ETC-SOLD-OUT-${i18n.language}.jpg`}
                    alt="etc."
                  />
                  <div className="card-content">
                    <ResponsiveImage
                      className="restaurant-logo"
                      src="svg/Playgrounds-etc-logo-registered-WHITE.svg"
                      alt="etc."
                    />
                    <ReactMarkdown className="description">
                      {t(
                        "entertainment.newYearsEve2026.content.dining.etc.title"
                      )}
                    </ReactMarkdown>
                    <p className="price">
                      {t(
                        "entertainment.newYearsEve2026.content.dining.etc.price"
                      )}
                    </p>
                    {/* <Button
                      bgColor="#D59947"
                      href={t(
                        "entertainment.newYearsEve2026.content.dining.etc.menuLink"
                      )}
                      label={t(
                        "entertainment.newYearsEve2026.content.dining.etc.menuText"
                      )}
                      color="var(--lightblack)"
                      hoverBgColor="#e6b366"
                      width="wide"
                    /> */}
                  </div>
                </DiningCard>
              </Col>
            </Row>

            {/* <ReservationNote>
              <ReactMarkdown>
                {t("entertainment.newYearsEve2026.preSale.title")}
              </ReactMarkdown>
              <ReactMarkdown>
                {t("entertainment.newYearsEve2026.preSale.subtitle")}
              </ReactMarkdown>
              <ReactMarkdown>
                {t("entertainment.newYearsEve2026.preSale.onSale")}
              </ReactMarkdown>
            </ReservationNote> */}

            {/* The Rail® Section */}
            <Row className="g-4 mb-5">
              <Col xs={12}>
                <RailSection>
                  <ResponsiveImage
                    src="entertainment/variety/new-years-eve-2026/LP-NYE-2025-RAIL.jpg"
                    alt={t("entertainment.newYearsEve2026.content.rail.title")}
                    className={"rail-image"}
                  />
                  <div className="rail-content">
                    <ResponsiveImage
                      className="rail-logo"
                      src="svg/RAIL-LOGO-CIRCLE-WHITE.svg"
                      alt="The Rail®"
                    />
                    <ReactMarkdown>
                      {t(
                        "entertainment.newYearsEve2026.content.rail.description"
                      )}
                    </ReactMarkdown>
                    <Button
                      bgColor="#D59947"
                      href={t(
                        "entertainment.newYearsEve2026.content.rail.menuLink"
                      )}
                      label={t(
                        "entertainment.newYearsEve2026.content.rail.menuText"
                      )}
                      color="var(--lightblack)"
                      hoverBgColor="#e6b366"
                      width="wide"
                    />
                  </div>
                </RailSection>
              </Col>
            </Row>
          </SectionWrapper>
        </container-div>
        {/* Gaming Promotions Section */}
        <container-div>
          <SectionWrapper>
            <TitleSection
              as={"h2"}
              title={t("entertainment.newYearsEve2026.content.gaming.title")}
              dark={false}
              borderColor="#D59947"
            />

            <Row className="g-4 mb-4">
              <Col xs={12} md={12}>
                <GamingCard>
                  <ResponsiveImage
                    src={`entertainment/variety/new-years-eve-2026/LP-NYE-2025-Win-a-million-${i18n.language}.jpg`}
                    alt={t(
                      "entertainment.newYearsEve2026.content.gaming.winAMillion.title"
                    )}
                  />
                  <div className="gaming-content">
                    <h3>
                      {t(
                        "entertainment.newYearsEve2026.content.gaming.winAMillion.title"
                      )}
                    </h3>
                    <ReactMarkdown>
                      {t(
                        "entertainment.newYearsEve2026.content.gaming.winAMillion.description"
                      )}
                    </ReactMarkdown>
                    <div className="draw-times">
                      <strong>
                        {t(
                          "entertainment.newYearsEve2026.content.gaming.winAMillion.drawTimesLabel"
                        )}
                      </strong>
                      <p>
                        {t(
                          "entertainment.newYearsEve2026.content.gaming.winAMillion.drawTimes"
                        )}
                      </p>
                    </div>
                    <p className="earn-entries">
                      {t(
                        "entertainment.newYearsEve2026.content.gaming.winAMillion.earnEntries"
                      )}
                    </p>
                    <Button
                      bgColor="#D59947"
                      href={t("routes.winAMillion2025")}
                      label={t(
                        "entertainment.newYearsEve2026.content.gaming.winAMillion.buttonText"
                      )}
                      color="var(--lightblack)"
                      hoverBgColor="#e6b366"
                      width="wide"
                    />
                  </div>
                </GamingCard>
              </Col>

              <Col xs={12} md={12}>
                <GamingCard>
                  <ResponsiveImage
                    src={`entertainment/variety/new-years-eve-2026/LP-NYE-2025-Winning-Wednesdays-${i18n.language}.jpg`}
                    alt={t(
                      "entertainment.newYearsEve2026.content.gaming.winningWednesday.title"
                    )}
                  />
                  <div className="gaming-content">
                    <h3 className="nye">
                      {t(
                        "entertainment.newYearsEve2026.content.gaming.winningWednesday.title"
                      )}
                    </h3>
                    <ReactMarkdown>
                      {t(
                        "entertainment.newYearsEve2026.content.gaming.winningWednesday.time"
                      )}
                    </ReactMarkdown>
                    <ReactMarkdown>
                      {t(
                        "entertainment.newYearsEve2026.content.gaming.winningWednesday.description"
                      )}
                    </ReactMarkdown>
                    <Button
                      bgColor="#D59947"
                      href={t("routes.winningWednesday")}
                      label={t(
                        "entertainment.newYearsEve2026.content.gaming.winningWednesday.buttonText"
                      )}
                      color="var(--lightblack)"
                      hoverBgColor="#e6b366"
                      width="wide"
                    />
                  </div>
                </GamingCard>
              </Col>
            </Row>
          </SectionWrapper>
        </container-div>{" "}
        {/* Entertainment Section */}
        <container-div>
          <EntertainmentSection>
            <TitleSection
              as={"h2"}
              title={t(
                "entertainment.newYearsEve2026.content.entertainment.title"
              )}
              dark={false}
              borderColor="#D59947"
            />

            <EntertainmentDetails>
              <div className="entertainment-item">
                <strong>
                  {t(
                    "entertainment.newYearsEve2026.content.entertainment.djLevel2.title"
                  )}
                  :
                </strong>
                <br />
                {t(
                  "entertainment.newYearsEve2026.content.entertainment.djLevel2.description"
                )}
              </div>
              <div className="entertainment-item">
                <strong>
                  {t(
                    "entertainment.newYearsEve2026.content.entertainment.roaming.title"
                  )}
                  :
                </strong>
                <br />
                {t(
                  "entertainment.newYearsEve2026.content.entertainment.roaming.description"
                )}
              </div>
            </EntertainmentDetails>

            <ResponsiveImage
              src="entertainment/variety/new-years-eve-2026/LP-NYE-2025-ENTERTAINMENT.jpg"
              alt={t(
                "entertainment.newYearsEve2026.content.entertainment.title"
              )}
            />

            <ClosingSection>
              <h2 className="closing-text">
                {t("entertainment.newYearsEve2026.content.closing.title")}
              </h2>
              <ReactMarkdown>
                {t("entertainment.newYearsEve2026.content.closing.subtitle")}
              </ReactMarkdown>
            </ClosingSection>
          </EntertainmentSection>
        </container-div>
      </MainContentDiv>
    </Div>
  );
};

const Div = styled.div`
  background-image: ${(props) => `url('${props.bgImage}')`};
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  .hero_text_container {
    display: none;
  }
  .title-section {
    padding-bottom: 0;
    p {
      font-size: 1.1rem;
    }
  }
`;

const MainContentDiv = styled.div`
  position: relative;
  width: 100%;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  background-attachment: fixed;
  color: var(--white);

  @media (max-width: 992px) {
    background-attachment: scroll;
  }

  color: var(--white);
  text-align: left;

  .row {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    position: relative;

    .col-12 {
      .subtitle-section {
        @media (min-width: 768px) {
          padding-top: 0;
        }
      }
    }
  }
`;

const SectionWrapper = styled.div`
  background: rgba(0, 0, 0, 0.7);
  padding: 1rem;
  margin-bottom: 2rem;
  border-radius: 8px;

  @media (min-width: 768px) {
    padding: 0 2rem 2rem 2rem;
  }
`;

const PreSaleFrame = styled.div`
  position: relative;
  border-radius: 12px;
  overflow: hidden;
`;

const PreSaleBar = styled.div`
  position: absolute;
  left: 30%;
  right: 0;
  bottom: 0;
  height: 80px;

  /* gold base expressed once */
  --gold: 209, 165, 87;

  /* ① fade from transparent to solid as we move right */
  background: linear-gradient(
    90deg,
    rgba(var(--gold), 0) 0,
    /* fully transparent at the very left */ rgba(var(--gold), 0.35) 40px,
    /* start appearing */ rgba(var(--gold), 0.65) 90px,
    rgba(var(--gold), 0.85) 140px,
    /* mostly opaque */ rgba(var(--gold), 0.9) 100%
      /* solid towards the right */
  );

  /* ② diagonal "cut" on the top-left of the bar */
  clip-path: polygon(18px 0, 100% 0, 100% 100%, 0 100%, 20% 0);

  @media (max-width: 768px) {
    height: 60px;
  }
`;

const PreSaleText = styled.span`
  position: absolute;
  right: 24px;
  bottom: 18px;
  color: #fff;
  font-weight: 900;
  line-height: 1;
  font-size: clamp(20px, 4vw, 44px);
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
`;

const PreSaleBanner = styled.div`
  background: #000;
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  h3 {
    margin: 1rem auto;
  }
  .image-container {
    position: relative;
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
`;

const DiningCard = styled.div`
  background: var(--lightblack);
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;

  img {
    width: 100%;
    height: auto;
    display: block;
    border-bottom: 4px solid #d59947;
  }
  .image-wrapper {
    position: relative;

    .seating-badge {
      position: absolute;
      left: 0;
      right: 0; /* full width */
      bottom: 0;
      padding: 0 1rem;

      --gold: 209, 165, 87;
      --notch: 42px; /* how far the top-right is “cut in” */

      /* Solid on the left → transparent on the right */
      background: linear-gradient(
        90deg,
        rgba(var(--gold), 0.9) 0%,
        rgba(var(--gold), 0.85) 40%,
        rgba(var(--gold), 0.55) 70%,
        rgba(var(--gold), 0) 100%
      );

      /* Diagonal cut on the right (bottom-right at full width, top-right inset) */
      clip-path: polygon(
        0 0,
        /* top-left */ calc(100% - var(--notch)) 0,
        /* top-right inset */ 70% 100%,
        /* bottom-right */ 0 100% /* bottom-left */
      );

      @media (max-width: 768px) {
        --notch: 28px; /* smaller notch on mobile */
      }

      .seating-info {
        color: #fff;
        font-weight: 700;
        margin: 0;

        p {
          margin: 0;
          color: #fff;
          font-size: 0.9rem;
        }
      }
      .seating-info-2 {
        color: #fff;
        font-weight: 700;
        margin: 0;

        p {
          margin: 0;
          color: #fff;
          font-size: 1.1rem;
          line-height: 1.2;
          strong {
            display: block;
            text-transform: uppercase;
          }
        }
      }
    }
  }

  .card-content {
    padding: 1.5rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    max-width: 400px;
    margin: 0 auto;

    h3 {
      font-size: 1.3rem;
      font-weight: 700;
      color: var(--white);
      margin: 0 0 0.5rem 0;
    }

    .performer {
      p {
        font-size: 0.95rem;
        margin: 0 0 0.5rem 0;
      }
    }

    .restaurant-logo {
      max-width: 250px;
      height: auto;
      margin: 0 auto 1rem;
      border-bottom: none;
    }

    /* .description {
      p {
        font-size: 1.5rem;
        margin: 0 0 1rem 0;
        font-weight: 600;
        max-width: 240px;
        line-height: 1;
      }
    } */

    .price {
      font-size: 0.95rem;
      margin: 0 0 1rem 0;
    }

    button,
    a {
      margin-top: auto;
      text-transform: uppercase;
    }
  }

  @media (max-width: 768px) {
    .card-content {
      padding: 1.25rem;
      margin: 0;
      h3 {
        font-size: 1.1rem;
      }

      /* .description {
        p {
          font-size: 1rem;
        }
      } */
    }
  }
`;

const ReservationNote = styled.div`
  max-width: 800px;
  text-align: center;
  margin: 2rem auto 0;
  h3:nth-child(2) {
    line-height: 0.8;
  }
  h3:nth-child(3) {
    margin-top: 2rem;
  }
`;

const RailSection = styled.div`
  background: var(--lightblack);
  overflow: hidden;

  .rail-image {
    width: 100%;
    height: auto;
    display: block;
    border-bottom: 4px solid #d59947;
  }

  .rail-content {
    padding: 1.5rem;
    text-align: center;

    .rail-logo {
      max-width: 180px;
      width: 100%;
      max-height: 130px;
      margin: 0 auto 1rem;
      height: auto;
    }
  }

  @media (max-width: 768px) {
    .rail-content {
      padding: 1.25rem;
    }
  }
`;

const GamingCard = styled.div`
  background: var(--lightblack);
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;

  img {
    width: 100%;
    height: auto;
    display: block;
    border-bottom: 4px solid #d59947;
  }

  .gaming-content {
    padding: 1.5rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    text-align: center;
    max-width: 750px;
    margin: 0 auto;

    .nye {
      text-transform: uppercase;
    }

    h3 {
      /* max-width: 440px; */
      font-size: 1.5rem;
      font-weight: 700;
      color: var(--white);
      margin: 0 auto 1rem auto;
    }

    p {
      margin-bottom: 0.75rem;
      color: var(--white);
    }

    .draw-times {
      margin-bottom: 0.75rem;

      strong {
        color: #d59947;
        display: block;
        font-size: 1.5rem;
      }
    }

    .earn-entries {
      font-weight: 600;
      margin-bottom: 1.5rem;
    }

    button,
    a {
      margin-top: auto;
    }
  }

  @media (max-width: 768px) {
    .gaming-content {
      padding: 1.25rem;

      h3 {
        font-size: 1.3rem;
      }

      .draw-times {
        strong {
          font-size: 1rem;
        }
      }

      .earn-entries {
        font-size: 0.95rem;
      }
    }
  }
`;

const EntertainmentSection = styled.div`
  text-align: left;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 8px;

  img {
    width: 100%;
    height: auto;
    display: block;
    margin-top: 2rem;
    border-bottom: 4px solid #d59947;
  }

  @media (min-width: 768px) {
    padding: 0 2rem 3rem 2rem;
  }
`;

const EntertainmentDetails = styled.div`
  max-width: 900px;
  margin: 0 auto 1.5rem auto;
  color: var(--white);

  .entertainment-item {
    margin-bottom: 1rem;
    line-height: 1.2;
    text-align: center;

    &:last-child {
      margin-bottom: 0;
    }

    strong {
      font-weight: 700;
      line-height: 16px;
    }
  }
`;

const ClosingSection = styled.div`
  text-align: center;
  margin: 2rem auto 0;
  padding: 1.5rem 1rem;
  background: var(--lightblack);

  .closing-text {
    font-size: 1.8rem;
    font-weight: bold;
    margin-bottom: 0.75rem;
    line-height: 1.3;
  }

  @media (max-width: 768px) {
    padding: 1.25rem 1rem;

    .closing-text {
      font-size: 1.3rem;
    }
  }
`;

export default NewYearsEve2026;
